import { render, staticRenderFns } from "./HAWBPart1.vue?vue&type=template&id=065d0848&scoped=true&"
import script from "./HAWBPart1.vue?vue&type=script&lang=js&"
export * from "./HAWBPart1.vue?vue&type=script&lang=js&"
import style0 from "./HAWBPart1.vue?vue&type=style&index=0&id=065d0848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d0848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065d0848')) {
      api.createRecord('065d0848', component.options)
    } else {
      api.reload('065d0848', component.options)
    }
    module.hot.accept("./HAWBPart1.vue?vue&type=template&id=065d0848&scoped=true&", function () {
      api.rerender('065d0848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/components/HAWBPart1.vue"
export default component.exports